export default __webpack_public_path__ + "static/media/logo-aom.4f273061.png";